import React from "react";
import { Box, Typography } from "@mui/material";
import { BRAND_COLOR, BRAND_HOVER } from "@kivunova/kivufrontendcommon";

const PRINT_ATTRIBUTION_HREF = "https://kivuims.com";

/** Small print footer on receipt / invoice layouts. */
export const PrintPlatformAttribution: React.FC = () => (
  <Typography
    component="div"
    sx={{
      fontSize: "9px",
      color: BRAND_COLOR,
      mt: 1.5,
      "@media print": { color: BRAND_COLOR }
    }}
  >
    Made with love by{" "}
    <Box
      component="a"
      href={PRINT_ATTRIBUTION_HREF}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: BRAND_COLOR,
        textDecoration: "underline",
        textUnderlineOffset: 2,
        "@media print": { color: BRAND_COLOR },
        "@media (hover: hover)": {
          "&:hover": { color: BRAND_HOVER }
        }
      }}
    >
      KivuIms
    </Box>
  </Typography>
);

export default PrintPlatformAttribution;
